module.exports = __webpack_public_path__ + "img/advan-team_2x.772a4e34.png";